import React, { useEffect, useRef } from "react";
import "./shopComp.css";
import "./shopsMain.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Earring_1 from "../../images/shopComp/images/img1.webp";
import Earring_2 from "../../images/shopComp/images/img2.webp";
import Earring_3 from "../../images/shopComp/images/img3.webp";
import Earring_4 from "../../images/shopComp/images/img4.webp";
import Earring_5 from "../../images/shopComp/images/img5.webp";
import Video1 from "../../images/shopComp/images/video_1.mp4";
import ShopIcon from "../../images/shopComp/images/shop.svg";
export default function shopComp() {
  return (
    <div className="shopComp-main">
      <div className="shopComp-header">
      What would you choose this Christmas?
        <br className="br-portrait" />{" "}
        <span className="second-header">Gifts or </span>&nbsp;{" "}
        <br /> <span className="forever">diamonds to remember?</span>
      </div>
      <div className="shopComp-container">
        {/* <div className="shopComp-element shopComp-video"></div> */}
        <video
          playsinline="true"
          autoplay="true"
          loop="true"
          muted="true"
          className="shopComp-element shopComp-video"
        >
          <source src={Video1} type="video/mp4" />
        </video>
        <div className="shopComp-element shopComp-product-1">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.com/product/126901/18K-white-gold-ring-with-0.94ct-diamonds"
          >
            <img className="zoom" alt="" src={'https://cdn.media.amplience.net/i/teilor/213044_WHITE_1'}></img>
            <img className="shop-icon" alt="" src={ShopIcon}></img>
          </a>
        </div>
        <div className="shopComp-element shopComp-product-2">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.com/product/116339/14K-white-gold-ring-with-0.97ct-diamonds"
          >
            <img className="zoom" alt="" src={'https://cdn.media.amplience.net/i/teilor/207875_WHITE_1'}></img>
            <img className="shop-icon" alt="" src={ShopIcon}></img>
          </a>
        </div>
        <div className="shopComp-element shopComp-product-3">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.com/product/104292/18K-white-gold-bracelet-with-4.18ct-diamonds"
          >
            <img className="zoom" alt="" src={'https://cdn.media.amplience.net/i/teilor/201531_WHITE_1'}></img>
            <img className="shop-icon" alt="" src={ShopIcon}></img>
          </a>
        </div>
        <div className="shopComp-element shopComp-product-4">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.com/product/121135/18K-white-gold-pendant-necklace-with-0.09ct-diamond-and-1.72ct-diamonds"
          >
            <img className="zoom" alt="" src={'https://cdn.media.amplience.net/i/teilor/208245_WHITE_1'}></img>
            <img className="shop-icon" alt="" src={ShopIcon}></img>
          </a>
        </div>
        <div className="shopComp-element shopComp-product-5">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.com/product/124005/18K-white-gold-necklace-with-13.29ct-diamonds"
          >
            <img className="zoom" alt="" src={'https://cdn.media.amplience.net/i/teilor/211236_WHITE_1'}></img>
            <img className="shop-icon" alt="" src={ShopIcon}></img>
          </a>
        </div>
      </div>
      <div className="component-button">
        <div className="component-button-border"></div>
        <div className="component-button-text">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.teilor.com/pure-diamonds"
          >
            Discover the collection
          </a>
        </div>
      </div>
    </div>
  );
}
